import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Globe2 } from "lucide-react";
import { api } from "../../lib/api";

const COUNTRY_NAMES_FR = {
    ML: "Mali", FR: "France", SN: "Sénégal", CI: "Côte d'Ivoire", BF: "Burkina Faso",
    NE: "Niger", TG: "Togo", BJ: "Bénin", GN: "Guinée", GW: "Guinée-Bissau",
    MR: "Mauritanie", CM: "Cameroun", CD: "RD Congo", CG: "Congo", GA: "Gabon",
    US: "États-Unis", CA: "Canada", GB: "Royaume-Uni", BE: "Belgique", CH: "Suisse",
    DE: "Allemagne", ES: "Espagne", IT: "Italie", NL: "Pays-Bas", MA: "Maroc",
    DZ: "Algérie", TN: "Tunisie", EG: "Égypte", ZA: "Afrique du Sud", NG: "Nigéria",
    IN: "Inde", CN: "Chine", RU: "Russie", BR: "Brésil", AE: "Émirats",
    SA: "Arabie saoudite", TR: "Turquie", XX: "Inconnu",
};

function flag(code) {
    if (!code || code.length !== 2 || code === "XX") return "🌐";
    const cp = [...code.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65);
    return String.fromCodePoint(...cp);
}

export default function VisitsByCountry() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/visits/countries").then((r) => setData(r.data)).catch(() => setData({ total: 0, countries: [] }));
    }, []);

    if (!data) return null;
    const top = (data.countries || []).slice(0, 10);
    const total = data.total || 0;

    return (
        <section className="bg-white border border-gray-100 p-6" data-testid="visits-by-country">
            <div className="flex items-center justify-between mb-5">
                <div>
                    <div className="text-[0.65rem] tracking-[0.24em] uppercase font-bold text-brand-gold">Trafic</div>
                    <h3 className="font-display text-xl text-brand-navy">Visites par pays</h3>
                </div>
                <div className="inline-flex items-center gap-2 text-xs text-gray-500">
                    <Globe2 className="w-3.5 h-3.5" />
                    <span>{total.toLocaleString("fr-FR")} visites</span>
                </div>
            </div>
            {top.length === 0 ? (
                <div className="text-center py-8 text-sm text-gray-400">Aucune visite enregistrée.</div>
            ) : (
                <ul className="space-y-3" data-testid="countries-list">
                    {top.map((c) => {
                        const pct = total ? Math.round((c.count / total) * 100) : 0;
                        return (
                            <li key={c.country}>
                                <div className="flex items-center justify-between text-sm mb-1">
                                    <span className="inline-flex items-center gap-2">
                                        <span className="text-lg leading-none" aria-hidden>{flag(c.country)}</span>
                                        <span className="text-brand-navy font-semibold">{COUNTRY_NAMES_FR[c.country] || c.country}</span>
                                        <span className="text-[0.6rem] tracking-[0.2em] uppercase text-gray-400 font-semibold">{c.country}</span>
                                    </span>
                                    <span className="text-brand-navy font-semibold tabular-nums">
                                        {c.count.toLocaleString("fr-FR")} <span className="text-xs text-gray-400 font-medium">· {pct}%</span>
                                    </span>
                                </div>
                                <div className="h-1 bg-gray-100 overflow-hidden">
                                    <motion.div
                                        initial={{ width: 0 }}
                                        animate={{ width: `${pct}%` }}
                                        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                                        className="h-full bg-brand-gold"
                                    />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
}
